<script>
	import { pref } from './SRSMonitorOptions.svelte'
  import {api} from '../api'
  import LedIndicator from './LEDIndicator.svelte';
	import { Link } from "svelte-navigator";

	const devices = api.devices.store

	export let isSolo = true

	function sortPref(pref) {
		if (!pref || !Array.isArray(pref)) return []
		pref.sort((a, b) => a.label?.localeCompare(b.label))
		return pref
	}
</script>

{#if $pref.showSRSMonitor}
	<div class="srsMonitor" class:solo={isSolo}>
		<h3>Live Surveillance Status</h3>
		{#each sortPref($pref.deviceIds) as d (d.value)}
			{@const device = $devices[d.value]}
			{#if device}
				<div class="srs">
					<LedIndicator color={device.state === 'ACTIVE' ? 'green' : 'red' } />
					<Link to={"/devices/" + device.id}>
						<div>{device.name}</div>
					</Link>
				</div>
			{/if}
		{/each}
	</div>
{/if}

<style>
	.srsMonitor {
		padding: 8px;
	}

	.srsMonitor.solo {
    position: absolute;
    margin-top:58px;
    margin-right:16px;
    right: 0;
    width: 275px;
    color: white;
    background-color: rgb(37, 37, 37);
    border:1px solid black;
	}

	.srsMonitor :global(a) {
		color: inherit;
	}

	.srsMonitor h3 {		
    margin:0;
		margin-bottom: 4px;
    padding:0;
    font-size:12pt;
	}

	.srs {
		display: flex;
		align-items: center;
		gap: 4px;
		margin-bottom: 4px;
	}

	.srs:last-child {
		margin-bottom: 0;
	}
</style>